module.exports = __webpack_public_path__ + "static/media/HS5081HJ.ea1d5477.jpg";